import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ScrollToService, ScrollToConfigOptions } from '@nicky-lenaers/ngx-scroll-to';
import { _ } from 'underscore';
import { Title, Meta } from '@angular/platform-browser';


@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FAQComponent implements OnInit, AfterViewInit {
  aboutHeight = 0;
  deregulationHeight = 0;
  switchingHeight = 0;
  contractHeight = 0;
  givebackHeight = 0;
  commercialHeight = 0;
  imageHeight = 0;
  scroll = 0;

  constructor(private _scrollToService: ScrollToService,private title: Title,private meta: Meta) { }
  ngOnInit() {
    //this.meta.removeTag('name=description');
    //this.meta.removeTag('name=keywords');
   // this.meta.removeTag('name=title');
 

    const self = this;

    const aboutSection = <HTMLElement>document.getElementById('faq-tab1');
    this.aboutHeight = aboutSection.offsetHeight;

    const deregulationSection = <HTMLElement>document.getElementById('faq-tab2');
    this.deregulationHeight = deregulationSection.offsetHeight;

    const switchingSection = <HTMLElement>document.getElementById('faq-tab3');
    this.switchingHeight = switchingSection.offsetHeight;

    const contractSection = <HTMLElement>document.getElementById('faq-tab4');
    this.contractHeight = contractSection.offsetHeight;

    const givebackSection = <HTMLElement>document.getElementById('faq-tab5');
    this.givebackHeight = givebackSection.offsetHeight;

    const commercialSection = <HTMLElement>document.getElementById('faq-tab6');
    this.commercialHeight = commercialSection.offsetHeight;

    const image = <HTMLElement>document.getElementById('imgHeight');
    this.imageHeight = image.offsetWidth;

    $(window).scroll(function () {
      const deregulationScrollTop = document.getElementById('faq-tab2');
      self.scroll = $(window).scrollTop();
      if (self.scroll >= 100) {
        $('.navfixed').addClass('navtop');
        $('.navmnu').addClass('fixed-top');
        $('.disimg').hide();
        $('.toplink').show();

        // Conditions are apply for to enable the active class when scroll the page(Tabs).
        if (self.scroll < self.aboutHeight) {
          self.activeremove();
          const abouttabvalue = document.getElementById('abouttabcontent');
          if(abouttabvalue != null){
            abouttabvalue.classList.add('active');
          }
          
        } else if ((self.scroll >= self.aboutHeight)
         && (self.scroll < self.aboutHeight + self.deregulationHeight + self.imageHeight)) {
          self.activeremove();
          const deregulationtabvalue = document.getElementById('deregulationtabcontent');
          deregulationtabvalue.classList.add('active');
        } else if ((self.scroll >= self.aboutHeight + self.deregulationHeight + self.imageHeight)
         && (self.scroll < self.aboutHeight + self.deregulationHeight + self.switchingHeight  + self.imageHeight)) {
          if (deregulationScrollTop.classList.contains('deregulationtop')) {
            deregulationScrollTop.classList.remove('deregulationtop');
          }
          self.activeremove();
          const switchingtabvalue = document.getElementById('switchingtabcontent');
          switchingtabvalue.classList.add('active');
        } else if ((self.scroll >= self.aboutHeight + self.deregulationHeight + self.switchingHeight + self.imageHeight)
         && (self.scroll < self.aboutHeight + self.deregulationHeight +
          self.switchingHeight + self.contractHeight + self.imageHeight)) {
          if (deregulationScrollTop.classList.contains('deregulationtop')) {
            deregulationScrollTop.classList.remove('deregulationtop');
          }
          self.activeremove();
          const contracttabvalue = document.getElementById('contracttabcontent');
          contracttabvalue.classList.add('active');
        } else if ((self.scroll >= self.aboutHeight + self.deregulationHeight +
          self.switchingHeight + self.contractHeight + self.imageHeight)
         && (self.scroll < self.aboutHeight + self.deregulationHeight +
          self.switchingHeight + self.contractHeight + self.givebackHeight + self.imageHeight)) {
            if (deregulationScrollTop.classList.contains('deregulationtop')) {
              deregulationScrollTop.classList.remove('deregulationtop');
            }
          self.activeremove();
          const givebacktabvalue = document.getElementById('givebacktabcontent');
          givebacktabvalue.classList.add('active');
        } else if (self.scroll >= self.aboutHeight + self.deregulationHeight +
          self.switchingHeight + self.contractHeight + self.givebackHeight + self.imageHeight) {
            if (deregulationScrollTop.classList.contains('deregulationtop')) {
              deregulationScrollTop.classList.remove('deregulationtop');
            }
          self.activeremove();
          const commercialtabvalue = document.getElementById('commercialtabcontent');
          commercialtabvalue.classList.add('active');
        }
      } else {
        $('.navfixed').removeClass('navtop');
        $('.navmnu').removeClass('fixed-top');
        $('.disimg').show();
        $('.toplink').hide();
      }
      $('.navfixed .nav-item').click(function () {
        sessionStorage['scrollPosition'] = $(window).scrollTop(150);
      });
      $('.toplink').click(function () {
        sessionStorage['scrollPosition'] = $(window).scrollTop(0);
      });
    });
    this.title.setTitle('FAQ | Honest Gorilla.com');
    this.meta.updateTag({name: 'keywords', content: 'frequently asked questions,faq,what is honest gorilla,energy plans,deregulation,energy deregulation,dereg101,infographic on energy deregulation,how does energy deregulation work,how does energy deregulation benefit me,honest gorilla giveback program,light of unity initiative,so powerful is the light of unity, is there a charge to switch providers,right of rescission,electricity contract termination fees,early termination fees,when is the best time to shop for a new energy provider,commercial energy,business energy,reverse-auction,negotiation,representation,fixed rate,variable rate,index rate,blend and extend'});
    this.meta.updateTag({name: 'description', content: 'Questions about who is Honest Gorilla, how deregulation works, the switching process, energy contracts, commercial energy and more are discussed here.'});
    this.meta.updateTag({name: 'author', content: 'HonestGorilla'});
    this.meta.updateTag({name: 'robots', content: 'index, follow'});
  }

  // This Function is used for to show the "active tab".
  faqclk(tabvalues, paddtopval, e) {
    // const deregulation = document.getElementById('faq-tab2');
    // if (this.scroll === 0 && tabvalues === 'deregulationtabcontent') {
    //   // console.log.log('****');
    //   deregulation.classList.add('deregulationtop');
    // } else {
    //   if (deregulation.classList.contains('deregulationtop')) {
    //     deregulation.classList.remove('deregulationtop');
    //   }
    // }
    // // console.log.log(e);
    const tabvalue = document.getElementById(tabvalues);
    // const padtopp = document.getElementById(paddtopval);
    // const abotpadd = document.getElementById('abouttabcontent');
      this.triggerScrollTo(e);
      this.activeremove();
      tabvalue.classList.add('active');
      const secondTab = document.getElementById('faq-tab2');
      const thirdTab = document.getElementById('faq-tab3');
      const sixTab = document.getElementById('faq-tab6');
      if (this.scroll === 0 && tabvalues === 'deregulationtabcontent') {
        secondTab.classList.add('extraPadd');
      }
      // else if (secondTab.classList.contains('extraPadd')) {
      //   secondTab.classList.remove('extraPadd');
      // }

      if (this.scroll === 0 && tabvalues === 'switchingtabcontent') {
        thirdTab.classList.add('thirdTabMargin');
      } else if (thirdTab.classList.contains('thirdTabMargin')) {
        thirdTab.classList.remove('thirdTabMargin');
      }
      if (this.scroll === 0 && tabvalues === 'commercialtabcontent') {
        sixTab.classList.add('sixTabMargin');
      } else if (sixTab.classList.contains('sixTabMargin')) {
        sixTab.classList.remove('sixTabMargin');
      }
  }

  public triggerScrollTo(destination) {
    const config: ScrollToConfigOptions = {
      target: destination,
      duration: 0,
      easing: 'easeOutElastic'
    };
    this._scrollToService.scrollTo(config);
  }

  // This function is used for to remove the active class for all Tabs.
  // activeremove() {
  //   const abouttabvalue = document.getElementById('abouttabcontent');
  //   const deregulationtabvalue = document.getElementById('deregulationtabcontent');
  //   const switchingtabvalue = document.getElementById('switchingtabcontent');
  //   const contracttabvalue = document.getElementById('contracttabcontent');
  //   const givebacktabvalue = document.getElementById('givebacktabcontent');
  //   const commercialtabvalue = document.getElementById('commercialtabcontent');
  //   abouttabvalue.classList.remove('active');
  //   deregulationtabvalue.classList.remove('active');
  //   switchingtabvalue.classList.remove('active');
  //   contracttabvalue.classList.remove('active');
  //   givebacktabvalue.classList.remove('active');
  //   commercialtabvalue.classList.remove('active');
  // }


  activeremove() {
    const elems = document.querySelectorAll('.active');
    if (elems !== null) {
      for (let i = 0; i < elems.length; ++i) {
        if (!_.contains(elems[i].classList, 'suppsubhead')) {
          elems[i].classList.remove('active');
        }
      }
    }
  }

  ngAfterViewInit(): void {
    $('.navbar-toggler').click(function () {
      $('.navbar').toggleClass('parent');
    });
  }
}


